<template>
  <div class="uploadLogPage">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column prop="requestId" label="Request ID" align="center" show-overflow-tooltip min-width="90">
        <template slot-scope="scope">{{ scope.row.requestId }}</template>
      </el-table-column>
      <el-table-column sortable="custom" prop="sn" label="SN" align="center" min-width="150">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" :content="scope.row.sn ? scope.row.sn : '-'" placement="top" :open-delay="300">
              <div class="textOverflow">
                {{ scope.row.sn ? scope.row.sn : "-" }}
              </div>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.sn"
              effect="dark"
              content="已将SN复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyTipSn">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyText(scope.row, scope.row.sn, 'copyTipSn')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="Action" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.action">{{ scope.row.action }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="Type" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.type ? scope.row.type : '-'" placement="top" :open-delay="300">
            <div class="textOverflow">
              {{ scope.row.type ? scope.row.type : "-" }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="body" label="报文" align="center">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" :content="scope.row.body ? scope.row.body : '-'" placement="top" :open-delay="300">
              <div class="textOverflow">
                {{ scope.row.body ? scope.row.body : "-" }}
              </div>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.body"
              effect="dark"
              content="已将报文复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyBody(scope.row)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="startDateTime" label="开始时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.startDateTime">{{
            scope.row.startDateTime
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="completionDateTime" label="完成时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column sortable="custom" prop="retryTimes" label="尝试次数" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column sortable="custom" prop="code" label="错误代码" align="center" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="{danger: scope.row.code != 0}">{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="result" label="结果" align="center" width="80">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" :content="scope.row.result ? scope.row.result : '上传中……'" placement="top" :open-delay="300">
              <div class="textOverflow">
                {{ scope.row.result ? scope.row.result : "(上传中)" }}
              </div>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.result"
              effect="dark"
              content="已将结果复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyTipResult">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyText(scope.row, scope.row.result, 'copyTipResult')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getUploadLogSearch"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import { apiUploadLogSearch } from "@/api/productionOrder.js";
export default {
  components: {
    pagination,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    uploadLogForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  methods: {
    // 表格数据
    async getUploadLogSearch(remove) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }

      const res = await apiUploadLogSearch({
        orderId: this.tabPaneValue,
        ...this.uploadLogForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });

      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getUploadLogSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getUploadLogSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getUploadLogSearch();
    },
    // 复制文本到剪贴板（tipField：控制对应列气泡提示的字段名）
    copyText(row, text, tipField) {
      const val = text || "";
      this._copyTimers = this._copyTimers || {};
      const showTip = () => {
        this.$set(row, tipField, true);
        clearTimeout(this._copyTimers[tipField]);
        this._copyTimers[tipField] = setTimeout(() => {
          this.$set(row, tipField, false);
        }, 1500);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(val).then(showTip);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = val;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        showTip();
      }
    },
    // 复制报文到剪贴板
    copyBody(row) {
      this.copyText(row, row.body, "copyTip");
    },
  },
  beforeDestroy() {
    const timers = this._copyTimers || {};
    Object.keys(timers).forEach((k) => clearTimeout(timers[k]));
  },
};
</script>

<style lang="less" scoped>
.uploadLogPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.bodyCell {
  position: relative;

  .textOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .copyBtn {
    display: none;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding: 0 2px;
    line-height: 1.2;
    cursor: pointer;
    color: var(--themeColor);
    background-color: var(--bgHover);
    border-radius: 2px;
    transition: color 0.2s, transform 0.2s;

    &:hover {
      color: var(--themeColorDark);
      transform: translateY(-50%) scale(1.2);
    }
  }

  &:hover .copyBtn {
    display: inline-block;
  }
}
</style>